import { Locale } from 'modules/i18n';

export const projectsListTranslation = {
  [Locale.en]: {
    notAdded: 'Not added yet',
  },
};
